export function getStoredValue(key, defaultValue, session=false) {
  try {
    const item = (session ? window.sessionStorage : window.localStorage).getItem(key);
    return item != null ? JSON.parse(item) : (typeof defaultValue === "function" ? defaultValue() : defaultValue);
  } catch (error) {
    console.error(error);
    return (typeof defaultValue === "function" ? defaultValue() : defaultValue);
  }
}

export function removedStoredValue(key, session=false) {
  try {
    (session ? window.sessionStorage : window.localStorage).removeItem(key);
  } catch (error) {
    console.error(error);
  }
}

export function setStoredValue(key, value, session=false) {
  try {
    (session ? window.sessionStorage : window.localStorage).setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(error);
  }
}

export function getCookies() {
  const result = [];
  for (const cookie of document.cookie.split(';')) {
    const parts = cookie.split('=');
    if (parts.length === 2) {
      result[parts[0].trim()] = decodeURIComponent(parts[1].trim());
    }
  }
  return result;
}

/* CONFIGURATION */

const isDev = (process.env.NODE_ENV === 'development');
const isLocalDev = isDev && false;
//const isTest = !isDev && process.env.PUBLIC_URL.includes('laplanner-test');

export const getProfilePath = (id, builder) => `/lost-ark/${builder ? 'la-builder' : 'laplanner'}/${id}`;
export function getAssetsPath(path, locale) {
  if (locale === 'de') {
    return process.env.PUBLIC_URL + `/game_de/${path}?${process.hashes?.[path] || ''}`;
  } else if (locale === 'es') {
    return process.env.PUBLIC_URL + `/game_es/${path}?${process.hashes?.[path] || ''}`;
  } else if (locale === 'fr') {
    return process.env.PUBLIC_URL + `/game_fr/${path}?${process.hashes?.[path] || ''}`;
  } else if (locale === 'ru') {
    return process.env.PUBLIC_URL + `/game_ru/${path}?${process.hashes?.[path] || ''}`;
  } else if (locale === 'kr') {
    return process.env.PUBLIC_URL + `/game_kr/${path}?${process.hashes?.[path] || ''}`;
  } else if (locale === 'ptr') {
    return process.env.PUBLIC_URL + `/game_ptr/${path}?${process.hashes?.[path] || ''}`;
  } else {
    return process.env.PUBLIC_URL + `/game/${path}?${process.hashes?.[path] || ''}`;
  }
}
export const getIconPath = /*isDev ? (path => process.env.PUBLIC_URL + `/icons/${path.toLowerCase()}.png`) :*/
  (path => `https://d3planner-assets.maxroll.gg/lost-ark/webp/${path.toLowerCase()}.webp`);
export const getApiPath = isLocalDev ? (action => `/${action === 'account' ? action : 'la' + action}`) : (action => `https://laplanner.maxroll.gg/${action}`);
export const getStaticApiPath = isLocalDev ? (action => `/${action === 'account' ? action : 'la' + action}`) : (action => `https://laplanner.maxroll.gg/laplanner-data/${action}`);

let _isEmbed = null;

export const isEmbed = () => _isEmbed;
export const EMBED_setEmbed = () => _isEmbed = true;
